<template>
<div class="col-12">
    <br />
    <div class="form-group">
        <h2>Omset dan Laba</h2>
        <label>Tanggal : {{ moment(this.$route.query.fromDate).format('L') }} - {{ moment(this.$route.query.toDate).format('L') }}</label>
    </div>
    <br />
    <div class="row">
        <div class="form-group col-6 text-left">
        <h2>Omset Produk : {{ profit.productGrossProfit }}</h2>
        </div>
        <div class="form-group col-6 text-left">
        <h2>Laba Produk : {{ profit.productNetProfit }}</h2>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-6 text-left">
        <h2>Omset Servis : {{ profit.serviceGrossProfit }}</h2>
        </div>
        <div class="form-group col-6 text-left">
        <h2>Laba Servis : {{ profit.serviceNetProfit }}</h2>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-6 text-left">
        <h1>Total Omset : {{ profit.grossProfit }}</h1>
        </div>
        <div class="form-group col-6 text-left">
        <h1>Total Laba : {{ profit.netProfit }}</h1>
        </div>
    </div>
</div>
</template>

<script>
import api from '../../../services/api'

export default {
    data() {
        return {
            profit: { }
        }
    },
    async created() {
        const profitApi = api('report/profit')
        const query = {
            params: {
                ...this.$route.query
            }
        }
        const { content } = await profitApi.getWithQuery(query)
        this.profit = content
    }
}
</script>